import React, { useRef, useEffect, useCallback, ReactNode } from 'react'
import { useSpring, animated } from 'react-spring'
import styled from 'styled-components'
import { MdClose } from 'react-icons/md'

interface CheckProps {
  showModal?: any
  setShowModal?: any
  children?: ReactNode
}

const BaseModal = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  height: 100vh;
  background: rgb(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  width: 100%;
  position: fixed;
  z-index: 10000000;
  opacity: 1;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
  }
  .modalWrapper {
    width: 500px;
    height: 100vh;
    background: ${({ theme }) => theme.colors.white};
    position: absolute;
    right: 0px;
    z-index: 100;
    border-radius: 10px;
    box-shadow: 0 5px 16px rgba(0, 0, 0, 0.4);
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
      height: auto;
      border-radius: 0px;
      top: 0px;
    }
  }
  .ModalTextContent {
    padding: 10px 47px 10px 47px;
    height: 100%;
  }
  .ClosedModalButton {
  }
`
const ClosedModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  z-index: 1000;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 36px;
    height: 36px;
    top: 60px;
  }
`

const CustomModal = ({
  showModal,
  setShowModal,
  children,
  ...rest
}: CheckProps) => {
  const modalRef = useRef(null)

  const animation = useSpring({
    config: {
      duration: 500,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? 'translateX(0px)' : 'translateX(800px)',
  })

  const closeModal = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === modalRef.current) {
      setShowModal(false)
    }
  }
  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && showModal) {
        setShowModal(false)
      }
    },
    [showModal, setShowModal]
  )

  useEffect(() => {
    document.addEventListener('keydown', keyPress)
    return () => document.removeEventListener('keydown', keyPress)
  }, [keyPress])

  return (
    <>
      {showModal ? (
        <BaseModal {...rest} onClick={closeModal} ref={modalRef}>
          <animated.div style={animation}>
            <div className="modalWrapper">
              <div
                className="ModalTextContent"
                onClick={() => setShowModal((prev: any) => !prev)}
              >
                {children}
              </div>
              <div className="ClosedModalButton">
                <ClosedModalButton
                  aria-label="Close modal"
                  onClick={() => setShowModal((prev: any) => !prev)}
                  className="ModalButton"
                />
              </div>
            </div>
          </animated.div>
        </BaseModal>
      ) : null}
    </>
  )
}

const ProfileNavModal = styled(CustomModal)`
  background: transparent;
  .modalWrapper {
    width: 176px;
    height: auto;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.cyanBlue};
    box-sizing: border-box;
    border-radius: 4px;
    right: 35px;
    overflow: hidden;
    top: 70px;
  }
  .ModalTextContent {
    padding: 2px 16px;
  }
  .ClosedModalButton {
    display: none;
  }
`
const KycModal = styled(CustomModal)`
  background: transparent;

  .modalWrapper {
    width: 444px;
    height: 416px;
    right: 30px;
    top: 150px;
    background: #e1f5fe;
    border-radius: 9.25px;
  }
  .ModalTextContent {
    padding: 10px 20px;
  }

  .ModalButton {
    width: 32px;
    color: ${({ theme }) => theme.colors.secondPrimary};
  }
`
export { CustomModal, ProfileNavModal, KycModal }
